import DropdownMenu from 'common/components/drop-downs/drop-down-menu';
import Button from 'common/components/buttons/button';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import {
  SegmentFilter,
  SegmentFilterBeingEdited,
  SegmentFilterValue
} from '../../segment-controls.types';
import { SegmentControlsFilterValueOperators } from 'features/segment-controls/constants/segment-controls-filter-value-operators';
import SegmentFilterValueDropdown from './segment-filter-value-dropdown';

interface SegmentControlFilterDropdownProps {
  filter?: SegmentFilterBeingEdited;
  onFilterAdded: () => void;
  onFilterBeingEditedChanged: (filter?: SegmentFilter) => void;
  onFilterSaved: () => void;
}

const SegmentFilterDropdown = ({
  filter,
  onFilterAdded,
  onFilterBeingEditedChanged,
  onFilterSaved
}: SegmentControlFilterDropdownProps) => {
  const onDropdownClicked = () => {
    onFilterAdded();
  };

  const onCloseDropdown = () => {
    if (filter) {
      onFilterBeingEditedChanged(undefined);
    }
  };

  const onFilterValueChanged = (
    newFilterValue: SegmentFilterValue,
    newFilterValueIndex: number
  ) => {
    const filterWithChanges: SegmentFilter = {
      ...filter!,
      values: filter!.values.map((value, valueIndex) =>
        valueIndex === newFilterValueIndex ? newFilterValue : value
      )
    };
    onFilterBeingEditedChanged(filterWithChanges);
  };

  const onFilterValueAdded = () => {
    const filterWithChanges: SegmentFilter = {
      ...filter!,
      values: [
        ...filter!.values,
        { value: '', valueOperator: SegmentControlsFilterValueOperators.EQUALS }
      ]
    };
    onFilterBeingEditedChanged(filterWithChanges);
  };

  const deleteFilterValue = (valueToDelete: SegmentFilterValue) => {
    const updatedValues = filter!.values.filter(
      (value) => value !== valueToDelete
    );
    const filterWithChanges: SegmentFilter = {
      ...filter!,
      values: updatedValues
    };
    onFilterBeingEditedChanged(filterWithChanges);
  };

  return (
    <div className="relative group flex">
      <DropdownMenu
        isDropdownOpen={filter !== undefined}
        containerClasses="flex relative w-10"
        buttonClasses="flex text-sm items-center py-2.5 px-3 justify-center bg-white rounded border border-neutral-200 w-60 flex-row-reverse px-3 py-2 bg-white"
        buttonIconClasses="ra-icons-generic-sort-2 flex text-lg"
        buttonLabel=""
        buttonLabelClasses=""
        hasExtraButtonIconClasses={true}
        extraButtonIconClasses="ra-icons-generic-plus flex text-xxxs"
        dropdownMenuClasses="z-40 top-11 w-108"
        onDropdownClicked={onDropdownClicked}
        onClickAway={onCloseDropdown}
      >
        {filter ? (
          <div className="p-3 group">
            <div>{filter.title}</div>
            {filter.values.map((value, index) => (
              <div className="mt-3 relative" key={index}>
                <SegmentFilterValueDropdown
                  filterValue={value}
                  isFirstFilterValue={index === 0}
                  onFilterValueChanged={(newFilterValue) =>
                    onFilterValueChanged(newFilterValue, index)
                  }
                  onDeleteFilterValue={() => deleteFilterValue(value)}
                />
              </div>
            ))}
            <div className="mt-3 flex justify-end">
              <div className="mr-2">
                <Button
                  identifier={`add-filter-${filter.id}`}
                  theme={ButtonTheme.CANCEL}
                  isDisabled={
                    !(filter.values[filter.values.length - 1].value !== '')
                  }
                  onClick={onFilterValueAdded}
                >
                  <span>OR</span>
                </Button>
              </div>
              <Button
                theme={ButtonTheme.SECONDARY}
                identifier="save-filter"
                isDisabled={
                  filter.values.length === 0 ||
                  filter.values[filter.values.length - 1].value === ''
                }
                onClick={onFilterSaved}
              >
                <span>Done</span>
              </Button>
            </div>
          </div>
        ) : (
          <></>
        )}
      </DropdownMenu>
    </div>
  );
};

export default SegmentFilterDropdown;
